export default __webpack_public_path__ + "static/media/flyingFrame.277795c4.png";